import React from 'react';
import PropTypes from 'prop-types';
import Appearance from './Appearance';

export default function Appearances({ appearances }) {
    if (!appearances.length) { return null; }

    return (
        <div className="list">
            <h3>{i18n.t('seller_profile.appearances')}</h3>
            <ul>
                {appearances.map((appearance, idx) =>
                    <Appearance appearance={appearance} key={idx}/>)}
            </ul>
        </div>
    );
}

Appearances.propTypes = {
    appearances: PropTypes.array
};

Appearances.defaultProps = {
    appearances: []
};



// WEBPACK FOOTER //
// ./src/common/InfoPanel/SellerProfile/Appearances/index.js